module.exports = __webpack_public_path__ + "static/startup-preview-1-e65b114c74d4adf54eac2ae86feca758.jpg";